import config from '@/helpers/config';

export enum LocaleEnum {
  EN_US = 'en-us',
  ES = 'es',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
  NL = 'nl',
  AR = 'ar',
}

export const localizedBuilderProductData = {
  [LocaleEnum.EN_US]: config.builderProductModelId,
  [LocaleEnum.ES]: config.builderProductModelIdSp,
  [LocaleEnum.DE]: config.builderProductModelIdDe,
  [LocaleEnum.FR]: config.builderProductModelIdFr,
  [LocaleEnum.IT]: config.builderProductModelIdIt,
  [LocaleEnum.NL]: config.builderProductModelIdNl,
  [LocaleEnum.AR]: config.builderProductModelIdAr,
};

export enum BuilderModelEnums {
  PAGE = 'page',
  PAGE_AR = 'page-ar',
  PAGE_DE = 'page-de',
  PAGE_ES = 'page-es',
  PAGE_FR = 'page-fr',
  PAGE_IT = 'page-it',
  PAGE_NL = 'page-nl',
  PRODUCT = 'product-page',
  PRODUCT_AR = 'product-page-ar',
  PRODUCT_DE = 'product-page-de',
  PRODUCT_ES = 'product-page-es',
  PRODUCT_FR = 'product-page-fr',
  PRODUCT_IT = 'product-page-it',
  PRODUCT_NL = 'product-page-nl',
}

export enum CustomBuilderComponents {
  SPACER = 'Spacer',
  CONTAINER = 'Container',
  TWO_COLUMN_TABLE = 'TwoColumnTable',
  SECTION_WITH_CHILDREN = 'SectionWithChildren',
  TEXT_BOX = 'TextBox',
  HEADING_BLOCK = 'HeadingBlock',
  PRODUCT_CAROUSEL = 'ProductCarousel',
  HERO = 'Hero',
  PRODUCT_LISTING = 'ProductListing',
  PRODUCT_MAIN = 'ProductMain',
  PRODUCT_SIZES = 'ProductSizes',
  RELATED_PRODUCTS = 'RelatedProducts',
  FILTERABLE_WHERE_TO_BUY = 'FilterableWhereToBuy',
  FILTERABLE_ACCORDION = 'FilterableAccordion',
  WHO_WE_ARE = 'WhoWeAre',
  FIND_PISTACHIOS = 'FindPistachios',
  CAMPAIGN_VIMEO_MODAL = 'CampaignVimeoModal',
  VIMEO_GALLERY = 'VimeoGallery',
  INFOGRAPHIC = 'Infographic',
  VOTE = 'Vote',
}
